import "./css/app.css";
import { initialiseApp } from "./js/app";
window.onload = () => {
	initialiseApp();
	window.addEventListener("resize", () => {
		window.document.body.style.width = `${window.innerWidth}`;
		window.document.body.style.height = `${window.innerHeight}`;
	});
};
